import type { components } from "@/api/types";

export type PersonEventColorTone = components["schemas"]["PersonEventColorTone"];

export const PERSON_EVENT_COLOR_TONES = [
  "gray",
  "dark",
  "blue",
  "yellow",
  "green",
  "red",
] as const satisfies readonly PersonEventColorTone[];

interface PersonEventColorToneTokens {
  background: string;
  foreground: string;
}

export const PERSON_EVENT_COLOR_TONE_TOKENS: Record<
  PersonEventColorTone,
  PersonEventColorToneTokens
> = {
  gray: {
    background: "var(--tone-neutral-solid-bg)",
    foreground: "var(--tone-neutral-solid-fg)",
  },
  dark: { background: "var(--soot-900)", foreground: "var(--steel-050)" },
  blue: {
    background: "var(--tone-info-solid-bg)",
    foreground: "var(--tone-info-solid-fg)",
  },
  yellow: {
    background: "var(--tone-caution-solid-bg)",
    foreground: "var(--tone-caution-solid-fg)",
  },
  green: {
    background: "var(--tone-success-solid-bg)",
    foreground: "var(--tone-success-solid-fg)",
  },
  red: {
    background: "var(--tone-danger-solid-bg)",
    foreground: "var(--tone-danger-solid-fg)",
  },
};
